import { Box, Link, Typography, Container, useTheme } from "@mui/material";
import React from "react";
import linkedin from "../Assets/linkedin.png";
import twitter from "../Assets/twitter.png";
import instagram from "../Assets/instagram.png";
import { useTranslation } from "react-i18next";
import RayaLogo from "../Assets/RayaLogoHwhite.png";

export default function Footer() {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      component="footer"
      sx={{
        color: theme.palette.text.primary,
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          justifyContent: "space-between",
          textAlign: { xs: "center", md: "left" },
          gap: 2,
        }}
      >
        {/* Social Media Icons */}
        <Box sx={{ display: "flex", gap: 2 }}>
          {[
            {
              img: linkedin,
              link: "https://www.linkedin.com/company/oman-water-week",
            },
            { img: twitter, link: "https://twitter.com/oman_water_week" },
            {
              img: instagram,
              link: "https://www.instagram.com/oman_water_week/",
            },
          ].map((social, index) => (
            <Link
              key={index}
              href={social.link}
              target="_blank"
              rel="noopener"
              sx={{
                transition: "opacity 0.3s ease",
                "&:hover": { opacity: 0.7 },
              }}
            >
              <img src={social.img} alt="social" style={{ height: 28 }} />
            </Link>
          ))}
        </Box>

        {/* Copyright */}
        <Typography
          variant="body2"
          sx={{
            fontSize: "0.85rem",
            textAlign: "center",
            flex: 1,
            order: { xs: 3, md: 2 },
            color: "#fff",
          }}
        >
          © {new Date().getFullYear()} All rights reserved.
        </Typography>

        {/* Organized By */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            order: { xs: 2, md: 3 },
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontSize: "0.85rem",
              textAlign: "right",
              color: "#fff",
            }}
          >
            {t("organizedBy")}
          </Typography>
          <Link
            href="https://www.rayaservices.com/"
            target="_blank"
            rel="noopener"
          >
            <img
              src={RayaLogo}
              alt="Raya"
              style={{
                height: 28,
                objectFit: "contain",
              }}
            />
          </Link>
        </Box>
      </Container>
    </Box>
  );
}
